import { createFileRoute } from '@tanstack/react-router';
import ActivitiesPage from '../../components/webdesigned/ActivitiesPage';
import WebDesignedPortal from '../../components/portals/WebDesignedPortal';

export const Route = createFileRoute('/webdesigned/activities')({
  component: () => (
    <WebDesignedPortal>
      <ActivitiesPage />
    </WebDesignedPortal>
  ),
});
